import { Trial } from 'src/features/trial/types'
import { createApiClient } from 'src/lib/api-client'

import { CreateReAgreementExplanationInput, Explanation } from '../../types'

export const createExplanationRevision = async ({
  trialUid,
  explanationUid,
  input,
}: {
  trialUid: Trial['uid']
  explanationUid: Explanation['uid']
  input: CreateReAgreementExplanationInput
}): Promise<void> => {
  const res = await createApiClient({
    path: '/trials/{trial_uid}/explanations/{explanation_uid}/revisions',
    httpMethod: 'post',
    params: {
      paths: {
        trial_uid: trialUid,
        explanation_uid: explanationUid,
      },
      body: {
        patient: {
          candidateId: input.candidateId,
          expDiseaseId: input.expDiseaseId ?? '',
          email: input.email,
          mobileNumber: input.phoneNumber,
        },
        revision: {
          docSets: input.docSets.map(docSet => ({
            icfDocumentSetUID: docSet.uid,
            index: docSet.index,
          })),
          members: input.members.map(member => ({
            trialHospitalUid: member.trialHospitalUid,
            trialMemberUid: member.memberUid,
          })),
          partnerTrialHospital: input.partnerTrialHospitalUid,
          type: input.type,
          withRepresentative: input.withRepresentative,
        },
      },
    },
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }
}
